export default (state = { data: [], loading: false, defaultResponse: true }, action) => {
    switch (action.type) {

        case 'OPERATIONAL_ALERTS_TYPES_REQUEST':
            return {
                data: [],
                loading: true,
                defaultResponse: true
            };

        case 'OPERATIONAL_ALERTS_TYPES_SUCCESS':
            return {
                data: action.payload,
                responseDefault: false,
                loading: false,
                success: true,
                error: false,
                defaultResponse: false
            };

        case 'OPERATIONAL_ALERTS_TYPES_FAILURE':
            return {
                data: [],
                error: true,
                responseDefault: false,
                loading: false,
                success: false,
                // userMessage: action.payload.response.data['usermessage'],
                defaultResponse: false
            };

        default:

            return state;

    }

};